import { asNumber } from "./objects";
import { concatTransformationMatrix, rotateDegrees } from './operators';
export const matrix = (a, b, c, d, e, f) => concatTransformationMatrix(a, b, c, d, e, f);
export const translate = (tx, ty) => concatTransformationMatrix(1, 0, 0, 1, tx, ty);
export const translateX = (tx) => concatTransformationMatrix(1, 0, 0, 1, tx, 0);
export const translateY = (ty) => concatTransformationMatrix(1, 0, 0, 1, 0, ty);
export const rotate = (angle) => rotateDegrees(angle);
export const scale = (sx, sy) => concatTransformationMatrix(sx, 0, 0, sy, 0, 0);
export const scaleX = (xPos) => concatTransformationMatrix(xPos, 0, 0, 0, 0, 0);
export const scaleY = (yPos) => concatTransformationMatrix(0, 0, 0, yPos, 0, 0);
export const skew = (skx, sky) => concatTransformationMatrix(1, Math.tan(asNumber(skx)), Math.tan(asNumber(sky)), 1, 0, 0);
export const skewX = (skx) => concatTransformationMatrix(1, Math.tan(asNumber(skx)), 0, 1, 0, 0);
export const skewY = (sky) => concatTransformationMatrix(1, 0, Math.tan(asNumber(sky)), 1, 0, 0);
export const transform = (str) => {
    if (!str)
        return;
    const ops = [];
    str = str.split(' ').join(',');
    const regex = /((.*?)\((.*?)\))/g;
    let match;
    while ((match = regex.exec(str))) {
        const type = match[2].split(',').join('');
        const args = match[3].split(',').map((arg) => parseFloat(arg));
        switch (type) {
            case 'matrix':
                ops.push(matrix(args[0], args[1], args[2], args[3], args[4], args[5]));
                break;
            case 'translate':
                if (args.length === 1) {
                    ops.push(translate(args[0], 0));
                    break;
                }
                if (args.length === 2) {
                    ops.push(translate(args[0], args[1]));
                    break;
                }
                break;
            case 'translateX':
                ops.push(translateX(args[0]));
                break;
            case 'translateY':
                ops.push(translateY(args[0]));
                break;
            case 'rotate':
                if (args.length === 1) {
                    ops.push(rotate(args[0]));
                    break;
                }
                if (args.length === 3) {
                    ops.push(...[
                        translate(args[1], args[2]),
                        rotate(args[0]),
                        translate(-args[1], -args[2]),
                    ]);
                    break;
                }
                break;
            case 'scale':
                if (args.length === 1) {
                    ops.push(scale(args[0], args[0]));
                    break;
                }
                if (args.length === 2) {
                    ops.push(scale(args[0], args[1]));
                    break;
                }
                break;
            case 'scaleX':
                ops.push(scaleX(args[0]));
                break;
            case 'scaleY':
                ops.push(scaleY(args[0]));
                break;
            case 'skew':
                ops.push(skew(args[0], args[1]));
                break;
            case 'skewX':
                ops.push(skewX(args[0]));
                break;
            case 'skewY':
                ops.push(skewY(args[0]));
                break;
        }
    }
    return ops.filter(Boolean);
};
//# sourceMappingURL=transform.js.map